import {
  EEventsChangesActions,
  EventsChangesActions,
} from '@myStore/events-changes/events-changes.actions';
import {
  IEventsChangesState,
  initialEventsChangesState,
} from '@myStore/events-changes/events-changes.state';

export const eventsChangesReducers = (
  state = initialEventsChangesState,
  actions: EventsChangesActions
): IEventsChangesState => {
  switch (actions.type) {
    case EEventsChangesActions.SetMaterialLoadingShow:
      return {
        ...state,
        materialLoading: actions.loading,
      };
    case EEventsChangesActions.SetLinkLoadingShow:
      return {
        ...state,
        linkLoading: actions.loading,
      };
    case EEventsChangesActions.CreateEventRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EEventsChangesActions.CreateEventSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EEventsChangesActions.CreateEventFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EEventsChangesActions.ClearCreateEventErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EEventsChangesActions.EditEventRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EEventsChangesActions.EditEventSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EEventsChangesActions.EditEventFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EEventsChangesActions.ClearEditEventErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EEventsChangesActions.DeleteEventRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EEventsChangesActions.DeleteEventSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EEventsChangesActions.DeleteEventFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };

    case EEventsChangesActions.AddEventFileRequest:
      return {
        ...state,
        fileLoading: true,
      };
    case EEventsChangesActions.AddEventFileSuccess:
      return {
        ...state,
        fileLoading: false,
      };
    case EEventsChangesActions.AddEventFileFailure:
      return {
        ...state,
        fileLoading: false,
        errors: actions.errors,
      };

    default:
      return state;
  }
};
